export default {"src":"/_next/static/media/TjLogo.4cf28542.svg","height":23,"width":210,"blurWidth":0,"blurHeight":0};